import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import { connect, useDispatch } from 'react-redux';
import {
  createSocialMedia,
  updateSocialMedia,
  getSocialMediaById,
} from 'src/actions/socialMediaActions';

const SocialMedia = ({ socialMedia, createSocialMedia, updateSocialMedia, loading }) => {
  const dispatch = useDispatch();
  const hospitalID = parseInt(localStorage.getItem('hospitalCode'), 10);

  const [socialLinks, setSocialLinks] = useState({
    FacebookURL: '',
    TwitterURL: '',
    InstagramURL: '',
    PinterestURL: '',
    LinkedinURL: '',
    YoutubeURL: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (hospitalID) {
      dispatch({ type: 'RESET_SOCIAL_MEDIA' });
      dispatch(getSocialMediaById(hospitalID));
    }
  }, [hospitalID, dispatch]);

  useEffect(() => {
    if (socialMedia) {
      const desiredFields = [
        'FacebookURL', 'TwitterURL', 'InstagramURL', 
        'PinterestURL', 'LinkedinURL', 'YoutubeURL'
      ];
      
      const filteredLinks = {};
      desiredFields.forEach(field => {
        filteredLinks[field] = socialMedia[field] || '';
      });
      
      setSocialLinks(filteredLinks);
    }
  }, [socialMedia]);

  const handleChange = (e) => {
    setSocialLinks({
      ...socialLinks,
      [e.target.name]: e.target.value,
    });
  };

  const normalizeUrl = (url) => {
    if (!url) return '';
    const urlString = String(url).trim();
    if (!urlString) return '';
    if (urlString.startsWith('http://') || urlString.startsWith('https://')) return urlString;
    return 'https://' + urlString;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const normalizedLinks = {};
    Object.entries(socialLinks).forEach(([key, value]) => {
      normalizedLinks[key] = normalizeUrl(value);
    });

    const payload = { hospitalID, ...normalizedLinks };

    try {
      if (socialMedia?.id) {
        await updateSocialMedia({ id: socialMedia.id, ...payload });
      } else {
        await createSocialMedia(payload);
      }

      // Wait for the update to complete before refreshing
      setTimeout(() => {
        dispatch(getSocialMediaById(hospitalID));
        setIsSubmitting(false);
      }, 1000); // 1 second delay to ensure data is saved

    } catch (error) {
      console.error('Error saving social media:', error);
      setIsSubmitting(false);
    }
  };

  return (
  <>
    {/* 1. The Rounded Header Section (Matches Payouts) */}
    <div className="page-header filter-bar rounded mb-4">
      <div className="row align-items-center">
        <div className="col">
          <h4 className="page-title">Social Media Links</h4>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/doctor/dashboard">Doctor Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">Social Media</li>
          </ul>
        </div>
      </div>
    </div>

    {/* 2. The Content Card */}
    <div className="card ">
      <div className='card-body'>
      <form>
        <div className="row">
          {Object.entries(socialLinks).map(([key, value]) => (
            <div className="col-md-6 mb-3" key={key}>
              <label className="form-label text-capitalize">
                {key.replace('URL', '')}
              </label>
              
              <div className="input-group">
                {/* Adding icons based on the key name */}
                <span className="input-group-text bg-light">
                   <i className={`fa-brands fa-${key.replace('URL', '').toLowerCase()}`}></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  name={key}
                  value={value || ''}
                  onChange={handleChange}
                  placeholder={`www.${key.replace('URL', '').toLowerCase()}.com/username`}
                  disabled={isSubmitting}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-2">
          <button 
            onClick={handleSubmit} 
            className="update-profile-button mt-3"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <><i className="fa-solid fa-spinner fa-spin me-2"></i> Saving...</>
            ) : (
              socialMedia?.id ? 'Update Social Links' : 'Save Social Links'
            )}
          </button>
        </div>
      </form>
      </div>
    </div>
  </>
);
};

const mapStateToProps = (state) => ({
  socialMedia: state.socialMedia, // Adjust based on your store structure
  loading: state.socialMedia.loading,
});

export default connect(mapStateToProps, {
  createSocialMedia,
  updateSocialMedia,
})(SocialMedia);